<template>
  <q-page class="sms-optout-container" padding>

    <!-- mymobility Logo -->
    <div class="mymo-logo row">
      <img src="/img/mymobility-zb-logo.png" alt="mymobility" />
    </div>

    <!-- Success Checkmark -->
    <div class="row" v-if="optOutSuccess">
      <q-icon name="fa-regular fa-check-circle" size="48px"></q-icon>
    </div>

    <!-- Opt out text/success message -->
    <div class="row">
      <p>
        {{ displayMessage }}
      </p>
    </div>

    <div class="bottom-content" v-if="!optOutSuccess">
      <div class="row phone-input-wrapper">
        <zbm-telephone-with-validation v-model="phoneTelNumberInputModel"
                                       :patient-country-code="derivedCountryCode" :placeholder="t('activate_phone_number')"
                                       :rules="[$zb.validators.phoneRequired()]" data-testid="phoneNumber" />
      </div>

      <!-- Submit Button -->
      <div class="row justify-center">
        <div class="col-auto">
          <zbm-btn @click="onSubmitClick" :color="$zb.enums.ButtonStdColorEnum.accent"
                   :height="$zb.enums.ButtonHeightEnum.md" data-testid="continueButton" :width="$zb.enums.ButtonWidthEnum.w300">
            {{ t('opt_out_of_texts_submit_button') }}
          </zbm-btn>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script setup lang="ts">
  import { ref, computed, onMounted } from 'vue';
  import { useLocalizationStore, useSessionStore } from 'src/store';
  import { useI18n } from 'vue-i18n';
  import { handleApiRequest } from 'src/api/handleApiRequest';
  import { smsOptOut } from 'src/api/endpoints/userWeb';
  import { useQuasar, useMeta } from 'quasar';

  useMeta({
    meta: [
      { name: 'robots', content: 'noindex' }
    ]
  });

  const props = defineProps({
    smsOptOutCode: {
      type: String,
      default: ''
    }
  });

  const localizationStore = useLocalizationStore(),
    sessionStore = useSessionStore(),
    { t } = useI18n(),
    $q = useQuasar(),
    optOutSuccess = ref(false);

  const phoneTelNumberInputModel = ref({
    value: '',
    phoneObject: {}
  });

  const derivedCountryCode = computed(() => {
    return localizationStore.region;
  });

  const displayMessage = computed(() => {
    if (optOutSuccess.value === true)
      return t('opt_out_of_texts_success');

    return t('opt_out_of_texts_how_to');
  });

  onMounted(() => {
    sessionStore.setIsFooterVisible(false);
  });

  async function onSubmitClick() {
    if (phoneTelNumberInputModel.value) {
      let phoneObject = phoneTelNumberInputModel.value.phoneObject;
      if (phoneObject.valid === true) {
        const response = await handleApiRequest(() =>
          smsOptOut({
            phone: phoneTelNumberInputModel.value.phoneObject.nationalNumber,
            optOutCode: props.smsOptOutCode
          }), null, $q
        );
        if (response) {
          optOutSuccess.value = true;
        }
      } else {
        $q.notify({ type: 'error', message: t('opt_out_of_texts_incorrect_phone_format') });
      }
    }
  }
</script>

<style lang="scss" scoped>
  @use 'sass:map';

  .sms-optout-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    align-items: center;
    background: map.get($co-brand-clrs, content-grd-bg-content);

    .bottom-content {
      margin-top: auto;
      display: flex;
      flex-direction: column;
      align-items: center;

      .phone-input-wrapper {
        padding-bottom: 20px;
      }
    }

    .q-icon {
      color: $content-low;
      padding-bottom: 20px;
    }

    img {
      max-width: 100%;
      max-height: 200px;
      padding-bottom: 20px;
    }
  }
</style>